module.exports = __webpack_public_path__ + "img/dominican-republic.b8f8b827.png";